export default __webpack_public_path__ + "static/media/HomeHero.b7532d17.jpg";